export default __webpack_public_path__ + "static/media/np_sign-up.0e16b4d3.svg";